import { angRoutes } from '../../constants/router';

// Every record id that goes into or comes out of a URL passes through here, so URL id
// encryption can be added in this one place later.

export function encodeRouteId(id: number): string {
  return String(id);
}

export function decodeRouteId(value: string | null | undefined): number | null {
  const trimmed = value?.trim() ?? '';
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const id = Number(trimmed);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export const recordLinks = {
  organization: (id: number): string =>
    `${angRoutes.organizationDetail.route}/${encodeRouteId(id)}`,
  organizationEdit: (id: number): string =>
    `${angRoutes.organizationEdit.route}/${encodeRouteId(id)}/edit`,
  user: (id: number): string => `${angRoutes.userDetail.route}/${encodeRouteId(id)}`,
  userEdit: (id: number): string => `${angRoutes.userEdit.route}/${encodeRouteId(id)}/edit`,
  facility: (id: number): string => `${angRoutes.facilityDetail.route}/${encodeRouteId(id)}`,
  facilityEdit: (id: number): string => `${angRoutes.facilityEdit.route}/${encodeRouteId(id)}/edit`,
  gateway: (id: number): string => `${angRoutes.gatewayDetail.route}/${encodeRouteId(id)}`,
  gatewayEdit: (id: number): string => `${angRoutes.gatewayEdit.route}/${encodeRouteId(id)}/edit`,
};
